<template>
  <hm-container bgTransparent noPadding>
    <div class="header" slot="header">
      <div class="selected-activity caption bold">用户特征画像</div>
      <div class="flex item-center">
        <!-- <img class="goods-image" :src="details.goodsImage" alt="商品图" /> -->
        <div class="bold goods-name">
          {{ details.goodName }}
        </div>
      </div>
      <div class="goods-info flex flex-between">
        <div>商品id:{{ details.goodId }}</div>
        <div>商品价格:￥{{ details.price }}</div>
        <div>所属品类:{{ details.goodCate }}</div>
        <div>上架时间:{{ details.upTime }}</div>
      </div>
    </div>
    <div class="main flex">
      <div class="portrait-tree-wrapper">
        <div class="selected-activity caption bold">全部标签</div>
        <el-tree default-expand-all :data="treeData" :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ data }">
            <span>{{ data.catName }}</span>
            <span
              v-if="!data.hasOwnProperty('children')"
              style="margin-right:10px"
            >
              <el-button
                type="text"
                size="small"
                @click="() => deleteData(data)"
              >
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div class="flex-1 table-wrapper">
        <div class="selected-activity caption bold">用户标签日志</div>
        <el-table stripe :data="details.logs">
          <el-table-column
            label="序号"
            header-align="center"
            align="center"
            type="index"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="content"
            show-overflow-tooltip
            label="日志内容"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            show-overflow-tooltip
            label="日志时间"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </hm-container>
</template>

<script>
export default {
  props: {
    goodId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      details: {
        launchTime: "",
        shopPrice: "",
        category: "",
        goodsId: "",
        goodsImage:
          "https://imgcdn.hemiao100.com/tag/SketchPng9c4340c9bed86cc0ccec5eca942de6e0d27984ce1cb93e050a0110a38075d84b.png",
        goodsName: "惠氏三段新西兰进口羊奶粉适合0-3月宝宝使用800g/罐"
      },
      logList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      treeData: [],
      defaultProps: {
        children: "children",
        label: "catName"
      }
    };
  },
  created() {
    this.getInit();
  },
  mounted() {},
  methods: {
    async getInit() {
      const { result } = await this.$store.dispatch(
        "queryPortraitDetailsByGoods",
        {
          relId: this.goodId
        }
      );
      if (result.cats) {
        result.cats.forEach(v => {
          if (v.children) {
            v.children.forEach(o => {
              o.catName = o.tagName + "：" + o.calcValue;
            });
          }
        });
      }
      this.treeData = [
        {
          catName: "商品画像",
          children: result.cats
        }
      ];
      this.details = result;
    },

    async deleteData(data) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("queryTagDelete", {
          tagName: data.tagName,
          source: "goodsPortrait",
          ids: this.details.goodId,
          state: "0"
        });
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.getInit();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  font-size: 14px;
  .goods-name {
    font-size: 16px;
  }
  .goods-image {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-right: 8px;
  }
  .goods-info {
    margin-top: 20px;
  }
}
.main {
  height: calc(100vh - 318px);
  .portrait-tree-wrapper {
    background: #fff;
    padding: 30px;
    margin-right: 10px;
    width: 490px;
    height: 100%;
    overflow-y: auto;
    .custom-tree-node {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

  .table-wrapper {
    padding: 30px;
    background: #fff;
    height: 100%;
    overflow-y: auto;
  }
}
</style>
